<template>
  <vx-card>
    <div>
      <heading size="h1" style-size="h4" class="mb-2">Apply for a position</heading>
      <p class="my-5">
        There are different ways you can apply for a position (work experience or a “real” job). On
        this page, there are three ways you can look at doing this. Click on the relevant tab below,
        according to how you want to complete your job application.
      </p>
      <vs-tabs alignment="fixed" :value="activeTab" class="overwrite-tabs">
        <vs-tab label="Complete an Application Letter">
          <div>
            <application-letter />
          </div>
        </vs-tab>
        <vs-tab label="Upload a Video Application">
          <div>
            <video-application />
          </div>
        </vs-tab>
        <vs-tab label="Use School Website e-Portfolio">
          <div>
            <e-portfolio />
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </vx-card>
</template>

<script>
import ApplicationLetter from '@/views/WorkExperiences/components/Prework/Student/Apply/ApplicationLetter';
import VideoApplication from '@/views/WorkExperiences/components/Prework/Student/Apply/VideoApplication';
import EPortfolio from '@/views/WorkExperiences/components/Prework/Student/Apply/EPortfolio';
import store from '@/store/store';
import router from '@/router/router';

export default {
  components: {
    ApplicationLetter,
    VideoApplication,
    EPortfolio,
  },
  computed: {
    prework() {
      return store.getters['authStudent/prework'];
    },
    settings() {
      return store.getters['authStudent/settings'];
    },
    activeTab() {
      if (
        typeof this.prework !== 'undefined' &&
        this.prework !== null &&
        this.prework.application_type > 0
      ) {
        return this.prework.application_type - 1;
      }
      return 0;
    },
  },
  mounted() {
    if (
      typeof this.settings['application'] !== 'undefined' &&
      this.settings['application'] == false
    ) {
      router.push('/student/dashboard');
    }
  },
};
</script>

<style lang="scss" scoped></style>
